import { useState, useEffect, useRef } from "react";
import "./styles/Individuals.css";
import InternalError from "../generales/InternalError";
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter, formatValue } from "../../utils/utils";
import LoadSimple from "../LoadSimple";
// Registrar componentes de Chart.js

const Devices = ({ handleShowPopup, server, languaje, mode, setHostSelected, hostSelected, openAddHostModal, showHistoric, pageActual,
    limitList,
    setPages,
    setLimitList,
    setPageActual,
    startLimit,
    setTotalRecord,
    listSelected,
    dataDevices, setDataDevices,
    dataCriticalities, dataAgencies,
    searchTerm,
    setSearchTerm,
    dataServers,
    dataList }) => {
    // const [hostSelected,setHostSelected]=useState({})
    // const [addHostModalOpen, setAddHostModalOpen] =useState(false);
    // function openAddHostModal() {

    //   //   console.log('open')
    //     setAddHostModalOpen(true);
    //   }

    //   function closeAddHostModal() {

    //       setAddHostModalOpen(false);
    //   }
    const [workStations, setWorkStations] = useState([]);
    // const [debouncedTerm, setDebouncedTerm] = useState("");
    const [isFirstRender, setIsFirstRender] = useState(true);
    const [isFirstRenderPA, setIsFirstRenderPA] = useState(true);
    const [isFirstRenderLP, setIsFirstRenderLP] = useState(true);
    const [msgError, setMsgError] = useState("")
    useEffect(() => {
        if (!isFirstRenderPA) {

            enviarDatos('page')
        } else { setIsFirstRenderPA(false) }
    }, [pageActual])
    useEffect(() => {
        // console.log("cambio la limite actual actual"+limitList)
        if (!isFirstRenderLP) {

            enviarDatos('rows')
        } else {
            setIsFirstRenderLP(false)

        }

    }, [limitList])
    useEffect(() => {
        if (!isFirstRender) {
            const timer = setTimeout(() => {
                setPageActual(1)
                enviarDatos('search') // Actualizar el valor después del debounce
            }, 1000);

            return () => clearTimeout(timer); // Limpiar el temporizador
        } else {
            setIsFirstRender(false); // Desactivar la bandera después del primer render
        }

    }, [searchTerm])


    // useEffect(() => {
    //   const interval = setInterval(() => {
    //     const newWorkStations = generateWorkStations(10); // Genera 5 estaciones de trabajo con valores aleatorios
    //     setWorkStations(newWorkStations);
    //   }, 2000); // Actualiza cada 2 segundos

    //   return () => clearInterval(interval); // Limpia el intervalo al desmontar el componente
    // }, []);
    // useEffect(()=>{
    //   search_data()
    //   // setInterval(search_data, 10000);
    // },[])
    const [wsDevices, setWsDevices] = useState(null); // Estado para el WebSocket
    const [wsHistoric, setWsHistoric] = useState(null); // Estado para el WebSocket
    const [response, setResponse] = useState(null); // Estado para la respuesta recibida
    // const [prevData, setPrevData] = useState([]);
    // const animationRefs = useRef({});
    useEffect(() => {

        // search_data()

        // console.log("-------------------WEBSOCKET 2------------------------------")

        // const wsUrl = server.ws + "/api/v1/cassia/dashboard/hosts_metrics_optimized";
        // console.log("--------------------WS URL:", wsUrl);
        // const websocketDevicesPrueba = new WebSocket(wsUrl);

        // console.log("--------------------readyState (init):", websocketDevicesPrueba.readyState);
        // websocketDevicesPrueba.onopen  = () => { 
        // console.log("--------------WS open---------------------");
        //   websocketDevicesPrueba.send(JSON.stringify({ tech_id: 27, page: 1, rows_per_page: 10, search: "" }));
        // };

        // websocketDevicesPrueba.onmessage = (e) => console.log("--------------------WS message:--------------------", e.data);
        // websocketDevicesPrueba.onerror = (e) => console.log("--------------------WS error", e);
        // websocketDevicesPrueba.onclose = (e) => console.log("--------------------WS close", e.code, e.reason);

        // console.log("-----------------------FIN WEBSOCKET--------------------")

        const websocketDevices = new WebSocket(server.ws + "/api/v1/cassia/dashboard/hosts_metrics_optimized");
        //    const websocketDevices = new WebSocket(server.ws+"/api/v1/cassia/dashboard/host_metrics");
        //const websocketAnalisis = new WebSocket(server.ws+"/api/v1/cassia/dashboard/hosts");
        websocketDevices.onopen = () => {
            setWsDevices(websocketDevices)
            const data = {
                tech_id: listSelected,
                page: pageActual,
                rows_per_page: parseInt(limitList),
                search: searchTerm
            };

            websocketDevices.send(JSON.stringify(data));

            //  setDataDevices({data:[],loading:true,error:dataDevices.error})
        };

        websocketDevices.onmessage = (event) => {
            const response = JSON.parse(event.data);
            //  setResponse(response); // Actualizar el estado con la respuesta
            setPages(response.data.total_pages)

            setTotalRecord(response.data.total_records)
            setDataDevices({ data: response.data.data, loading: false, error: {} })
        };

        websocketDevices.onerror = (error) => {
            console.error("Error en el WebSocket:", error);
        };

        websocketDevices.onclose = () => {
            setMsgError("Error de conexión con el socket, favor se recargar la pantalla, si el problema persiste favor de reportarlo.")
            setDataDevices({ data: [], loading: false, error: {} })
        };


        return () => {
            websocketDevices.close()
            // websocketAnalisis.close();
        };
    }, []);
    const enviarDatos = (source) => {
        // if (!wsDevices || wsDevices.readyState !== WebSocket.OPEN) {
        //   console.error("El WebSocket no está listo para enviar datos.");
        //   return;
        // }

        const data = {
            tech_id: listSelected,
            page: (source == 'search') ? 1 : pageActual,
            rows_per_page: parseInt(limitList),
            search: searchTerm.replace(" ", "")
        };
        setDataDevices({ data: dataDevices.data, loading: true, error: dataDevices.error })
        wsDevices.send(JSON.stringify(data));
    };
    const token_item = localStorage.getItem('access_token')
    function search_data() {
        setDataDevices({ data: dataDevices.data, loading: true, error: dataDevices.error })
        const fetchData = async () => {
            // console.log(server.url+'/api/v1/cassia/diagnosta/'+data.ip)
            try {
                const response = await fetch(server.url + '/api/v1/cassia/dashboard/hosts_metrics/' + listSelected, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token_item}`,
                    },
                });
                // console.log(response)
                if (response.ok) {
                    const response_data = await response.json();

                    setDataDevices({ data: response_data.message, loading: false, error: dataDevices.error })

                    // setDataAnalisis(response_data.data)
                } else {
                    throw new Error('Error en la solicitud');
                }
            } catch (error) {
                //   setInternalError(true)
            }
        };
        fetchData();
    }
    const [prevData, setPrevData] = useState([]);
    const animationRefs = useRef({});
    useEffect(() => {
        // Comparar datos actuales con previos
        if (prevData.length) {
            dataDevices.data.forEach((host, hostIndex) => {
                host.metrics.forEach((metric, metricIndex) => {
                    const prevHost = prevData[hostIndex];
                    const prevMetric = prevHost?.metrics[metricIndex];
                    const refKey = `${hostIndex}-${metricIndex}`;
                    const ref = animationRefs.current[refKey];

                    if (prevMetric && ref) {
                        const prevValue = parseFloat(prevMetric.value);
                        const currentValue = parseFloat(metric.value);

                        if (prevValue !== currentValue) {
                            const isIncreasing = currentValue > prevValue;

                            // Aplicar clase de animación
                            ref.classList.add(isIncreasing ? "animate-increase-device" : "animate-decrease-device");
                            setTimeout(() => {
                                ref.classList.remove(isIncreasing ? "animate-increase-device" : "animate-decrease-device");
                            }, 1000);
                        }
                    }
                });
            });
        }

        // Actualizar datos previos
        setPrevData(JSON.parse(JSON.stringify(dataDevices.data)));
    }, [dataDevices.data]);
    // useEffect(() => {
    //   console.log("cambian valores")
    //   if (prevData.length) {
    //     dataDevices.data.forEach((host, hostIndex) => {
    //       const prevHost = prevData[hostIndex];
    //       const ref = animationRefs.current[hostIndex];

    //       if (prevHost && ref) {
    //         // Detectar si alguna métrica cambió
    //         const hasChanges = host.metrics.some((metric, metricIndex) => {
    //           const prevMetric = prevHost.metrics[metricIndex];
    //           return (
    //             prevMetric &&
    //             parseFloat(metric.value) !== parseFloat(prevMetric.value)
    //           );
    //         });

    //         if (hasChanges) {
    //           // Aplicar animación
    //           ref.classList.add("animate-change-device");
    //           setTimeout(() => ref.classList.remove("animate-change-device"), 3000);
    //         }
    //       }
    //     });
    //   }

    //   // Actualizar datos previos
    //   setPrevData(JSON.parse(JSON.stringify(dataDevices.data)));
    // }, [dataDevices.data]);
    function checkType(value) {
        if (!isNaN(value) && !isNaN(parseFloat(value))) {
            return Number.isInteger(parseFloat(value)) ? "Entero" : "Flotante";
        }
        return "String";
    }

    const getLatestUpdate = (metrics = []) => {
        if (!metrics.length) return "—";
        // Asume timestamps en formato comparable (ISO o "YYYY-MM-DD HH:mm:ss")
        return metrics.reduce((latest, m) => {
            const a = (latest || "");
            const b = (m.last_update || "");
            return b > a ? b : a;
        }, "");
    };


    return (
        <>
            <div className="main-cont-graf-monitor">
                <div className="compact-graf-monitor">
                    {

                        (dataDevices.loading) ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}><LoadSimple></LoadSimple></div> :
                            <section class='FlexContainerIndividuals'>
                                {/* {workStations} */}
                                {
                                    (dataDevices.data.length == 0 && dataDevices.loading == false) ?
                                        ((msgError == "") ? <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', color: 'var(--txt-color)' }}>Sin resultados</div> :
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', color: 'var(--red-alert)' }}>{msgError}</div>)
                                        :
                                        // dataDevices.data.map((element,index)=>(
                                        dataList
                                            .map((element, hostIndex) => (
                                                <div className="cont-globe">
                                                    <div className="globe-info" key={element.hostid}  >
                                                        <div className="globe-title-info titleIndividuals  tooltip-container-individuals">
                                                            {element.hostname}
                                                            {/* {'Bosques_Demo_Printer_Kyocera_TASKALFA 3051ci_PISO5'} */}
                                                        </div>



                                                        <div style={{
                                                            display: 'block',
                                                            height: '90%',
                                                            overflow: 'auto'
                                                        }}>
                                                            {/* IP + Contador de métricas */}
                                                            <div style={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                padding: '10px 14px',
                                                                background: mode === 'Dark' ? '#334155' : '#f8fafc',
                                                                borderBottom: '1px solid #e2e8f0',
                                                                fontSize: 10
                                                            }}>
                                                                <span style={{
                                                                    color: '#1a56db',
                                                                    fontWeight: 500,
                                                                    fontFamily: "'DM Mono', monospace"
                                                                }}>
                                                                    IP: {element.ip}
                                                                </span>
                                                                <span style={{
                                                                    color: mode === 'Dark' ? '#cbd5e1' : '#64748b'
                                                                }}>
                                                                    ({element.metrics.length}) {capitalizeFirstLetter(lang[languaje]['metricasCapturadas'])}
                                                                </span>
                                                            </div>

                                                            {/* Tabla de métricas */}
                                                            <div style={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                overflow: 'hidden',
                                                                height: '75%'
                                                            }}>
                                                                {/* Header de tabla */}
                                                                <div style={{
                                                                    display: 'grid',
                                                                    gridTemplateColumns: '1.5fr 1fr 1.2fr',
                                                                    background: mode === 'Dark' ? '#475569' : '#f1f5f9',
                                                                    padding: '7px 10px',
                                                                    fontSize: 9,
                                                                    fontWeight: 600,
                                                                    color: mode === 'Dark' ? '#f1f5f9' : '#64748b',
                                                                    textTransform: 'uppercase',
                                                                    letterSpacing: '0.05em',
                                                                    borderBottom: '1px solid #e2e8f0',
                                                                    position: 'sticky',
                                                                    top: 0,
                                                                    zIndex: 1
                                                                }}>
                                                                    <div style={{ textAlign: 'left' }}>
                                                                        {capitalizeFirstLetter(lang[languaje]['metrica'])}
                                                                    </div>
                                                                    <div style={{ textAlign: 'center' }}>
                                                                        {capitalizeFirstLetter(lang[languaje]['valor'])}
                                                                    </div>
                                                                    <div style={{ textAlign: 'right' }}>
                                                                        {capitalizeFirstLetter(lang[languaje]['ultimaActualizacion'])}
                                                                    </div>
                                                                </div>

                                                                {/* Lista de métricas scrollable */}
                                                                <div style={{
                                                                    maxHeight: '180px',
                                                                    overflowY: 'auto',
                                                                    overflowX: 'hidden'
                                                                }}>
                                                                    {element.metrics.length === 0 ? (
                                                                        <div style={{
                                                                            padding: '20px',
                                                                            textAlign: 'center',
                                                                            color: '#94a3b8',
                                                                            fontSize: 12
                                                                        }}>
                                                                            {capitalizeFirstLetter(lang[languaje]['sinMetricas'])}
                                                                        </div>
                                                                    ) : (
                                                                        element.metrics.map((metric, metricIndex) => {
                                                                            const isPercent = metric.units === "%";
                                                                            const numericValue = parseFloat(metric.value);
                                                                            const barColor = (metric.danger == 1) ? '#db2777' : '#057a55';

                                                                            return (
                                                                                <div
                                                                                    key={metric.item_key}
                                                                                    ref={(el) => {
                                                                                        const refKey = `${hostIndex}-${metricIndex}`;
                                                                                        if (!animationRefs.current[refKey]) {
                                                                                            animationRefs.current[refKey] = el;
                                                                                        }
                                                                                    }}
                                                                                    style={{
                                                                                        display: 'grid',
                                                                                        gridTemplateColumns: '1.5fr 1fr 1.2fr',
                                                                                        padding: '8px 10px',
                                                                                        fontSize: 10,
                                                                                        borderBottom: '1px solid #f1f5f9',
                                                                                        background: metricIndex % 2 === 0
                                                                                            ? (mode === 'Dark' ? '#334155' : '#fff')
                                                                                            : (mode === 'Dark' ? '#1e293b' : '#fafafa'),
                                                                                        transition: 'background 0.15s',
                                                                                        alignItems: 'center'
                                                                                    }}
                                                                                    onMouseEnter={e => e.currentTarget.style.background = mode === 'Dark' ? '#475569' : '#f1f5f9'}
                                                                                    onMouseLeave={e => e.currentTarget.style.background = metricIndex % 2 === 0
                                                                                        ? (mode === 'Dark' ? '#334155' : '#fff')
                                                                                        : (mode === 'Dark' ? '#1e293b' : '#fafafa')}
                                                                                >
                                                                                    {/* Nombre métrica */}
                                                                                    <div style={{
                                                                                        fontWeight: 500,
                                                                                        color: mode === 'Dark' ? '#f1f5f9' : '#334155',
                                                                                        overflow: 'hidden',
                                                                                        textOverflow: 'ellipsis',
                                                                                        whiteSpace: 'nowrap',
                                                                                        textAlign: 'left'
                                                                                    }}>
                                                                                        {metric.name}
                                                                                    </div>

                                                                                    {/* Valor */}
                                                                                    <div style={{
                                                                                        fontWeight: 600,
                                                                                        textAlign: 'center'
                                                                                    }}>
                                                                                        {isPercent && !isNaN(numericValue) ? (
                                                                                            <div style={{
                                                                                                position: 'relative',
                                                                                                width: '70px',
                                                                                                height: '18px',
                                                                                                background: 'rgba(0,0,0,0.1)',
                                                                                                borderRadius: 4,
                                                                                                overflow: 'hidden',
                                                                                                margin: '0 auto'
                                                                                            }}>
                                                                                                <div style={{
                                                                                                    position: 'absolute',
                                                                                                    left: 0,
                                                                                                    top: 0,
                                                                                                    height: '100%',
                                                                                                    width: `${numericValue}%`,
                                                                                                    background: barColor,
                                                                                                    transition: 'width 0.3s ease'
                                                                                                }} />
                                                                                                <span style={{
                                                                                                    position: 'relative',
                                                                                                    zIndex: 1,
                                                                                                    fontSize: 9,
                                                                                                    color: '#fff',
                                                                                                    fontWeight: 600,
                                                                                                    textShadow: '0 1px 2px rgba(0,0,0,0.3)'
                                                                                                }}>
                                                                                                    {formatValue(metric.value)}%
                                                                                                </span>
                                                                                            </div>
                                                                                        ) : (
                                                                                            <span style={{
                                                                                                color: barColor,
                                                                                                fontFamily: checkType(metric.value) !== 'String' ? "'DM Mono', monospace" : 'inherit'
                                                                                            }}>
                                                                                                {(checkType(metric.value) === 'String')
                                                                                                    ? metric.value
                                                                                                    : formatValue(metric.value) + " " + metric.units}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>

                                                                                    {/* Última actualización */}
                                                                                    <div style={{
                                                                                        color: mode === 'Dark' ? '#94a3b8' : '#64748b',
                                                                                        fontSize: 10,
                                                                                        textAlign: 'right',
                                                                                        fontFamily: "'DM Mono', monospace"
                                                                                    }}>
                                                                                        {metric.last_update}
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })
                                                                    )}
                                                                </div>
                                                            </div>

                                                            {/* AQUÍ VA TU BOTÓN "Ver detalle" ORIGINAL - NO MODIFICADO */}
                                                            <div className="globe-title-info individualsInfo cont-btn-historical ver-detalle-demo"
                                                                style={{ width: '100%', height: '10%' }}
                                                                onClick={() => { showHistoric(element) }}>
                                                                <div className="txt-info-individual"
                                                                    style={{ width: '10%', color: 'var(--main-color)', left: '0%', textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                                                                    <img
                                                                        style={{ width: '40%' }}
                                                                        src={"/iconos/grafic_line.png"}
                                                                        name="provicionamiento"
                                                                    />
                                                                </div>
                                                                <div className="txt-info-individual"
                                                                    style={{ width: 'auto', color: 'var(--white-color)', left: '0%', textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                                                                    {capitalizeFirstLetter(lang[languaje]['verDetalle'])}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            ))


                                }

                                {/* <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div> */}
                            </section>
                    }
                </div>
            </div>
        </>
    );
};

export default Devices;
